
import { SlotMath } from 'slot-math'
import { barrel as barrelConfig } from 'cfg/slot-config'
import { doublegame as doubleGameConfig } from 'cfg/doublegame-config'
import helpConfig from 'cfg/help-config'
import { SlotScene } from 'slot-scene'
import SlotWinPresenter from 'slot_win_presenter'
import slot_config from 'cfg/slot-config'
import { Barrel } from 'barrel'
import { HelpScene } from 'helpscene'

/** Completes currently yet imperative structures with default ones which might not be specifically created by lib user.*/
export default function( c, spec, space )
{
    let math = c.math
    if ( ! math && c.slotScene && c.slotScene.view && c.slotScene.view.slotPresenter ) math = c.slotScene.view.slotPresenter._slotMath
    if ( ! math ) math = new SlotMath( undefined, spec )
    c.math = math
    space.s( 'math' ).next( math )

    let z = 0
    function push( name, what )
    {
        c[ name ] = c[ name ] || {}
        c[ name ].view = what
        c[ name ].z = z
        ++ z
    }

    let slotScene = c.slotScene ? c.slotScene.view : undefined
    let default_slot_scene = false
    if ( ! slotScene )
    {
        const presenter = new SlotWinPresenter( math, slot_config, undefined, space )
        slotScene = new SlotScene( spec, math, slot_config, presenter )
        default_slot_scene = true
        slotScene.addChild( slotScene.barrelContainer )
        slotScene.addChild( presenter )
    }
    push( 'slotScene', slotScene )
    space.s( 'presenter' ).next( c.slotScene.slotPresenter )

    let barrel = c.barrel
    if ( ! barrel && barrelConfig ) {
        barrel = new Barrel(barrelConfig, barrelConfig.symbolsCount)
        slotScene.setBarrel(barrel)
        c.barrel = barrel
    }
    space.s('barrel').next(barrel)
    
    if ( default_slot_scene && barrel ) {
        // определенно невыигрышная ситуация
        // с нее начнется вращение барабанов если сцена восстановится в этом состоянии
        slotScene.barrel.setCurrentElements( [3,5,1,7,4,3,8,0,6,7,2,4,0,6,7] )
        slotScene.barrel.setBlurSpeed( 3000 )
        slotScene.barrel.setBlurRotationTime( 0.23 )
    }
    
    if ( spec.risks && spec.risks[0] ) doubleGameConfig.suits = spec.risks[ 0 ].specification.suitNames
    let risk = c.doubleGameScene ? c.doubleGameScene.view : undefined
    if ( ! risk ) risk = new PIXI.Container
    space.s( 'risk_scene' ).next( risk )
    push( 'doubleGameScene', risk )

    let help = c.helpScene ? c.helpScene.view : undefined
    if ( ! help ) help = new HelpScene( null, null, math, helpConfig.help )
    space.s( 'help_scene' ).next( help )
    push( 'helpScene', help )
}





// WEBPACK FOOTER //
// ./src/library/imperative.es6